import { BaseDataChart } from '@components/baseDataChart';
import { BaseDataEquity } from '@components/baseDataEquity';
import { FileLink } from '@components/fileLink';
import { ItemListEntry } from '@components/itemListEntry';
import { useFragment } from 'react-relay';
import { baseDataFragment } from './BaseData.relay';
import type { BaseDataProps } from './types';

export const BaseData: React.FC<BaseDataProps> = ({ component }) => {
  const data = useFragment(baseDataFragment, component);

  return (
    <div className="Widget-row mb-12 flex w-full flex-wrap items-start justify-between max-[1100px]:w-full max-[600px]:mb-8">
      <div className="Widget-header mb-4 w-full border-b border-black text-left font-heading text-2xl leading-[1.3] text-black max-[700px]:text-base max-[700px]:leading-6 [&>span]:inline-block [&>span]:border-b [&>span]:border-accent [&>span]:-mb-px">
        <span>{data.header}</span>
      </div>
      <div className="Widget-row mb-12 flex w-full flex-wrap items-start justify-between max-[1100px]:w-full max-[600px]:mb-8">
        <div className="Widget-col w-[45%] max-[1100px]:w-full">
          <div className="BaseData-entries">{data?.entries?.edges?.map((component) => (component?.node?.value ? <ItemListEntry key={component.node.value} component={component.node} /> : null))}</div>
          {data.chart ? <BaseDataChart chart={data.chart} /> : null}
        </div>
        <div className="Widget-col w-[45%] max-[1100px]:w-full">
          <div className="BaseData-equity mb-[45px] max-[600px]:mb-0">{data.equity ? <BaseDataEquity content={data.equity} /> : null}</div>
          {/* biome-ignore lint/suspicious/noArrayIndexKey: is static */}
          {data?.files?.slice(0, 2).map((fileLink, idx) => (fileLink ? <FileLink key={idx} expanded={false} fileLink={fileLink} /> : null))}
        </div>
      </div>
    </div>
  );
};
